import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivityLoggerService } from 'src/app/_shared/service/activity-logger.service';
import { AppState } from 'src/app/app.state';
import { CurrencyFormatterPipe } from 'src/app/shared/pipe/currency-formatter.pipe';
import { IsValueExistPipe } from 'src/app/shared/pipe/is-value-exist.pipe';
import constant from 'src/constant.json';
import { environment } from 'src/environments/environment';
import { MyHomeService } from '../../service/my-home.service';
import { MyHomeState } from '../../state/my-home.state';

@Component({
  selector: 'app-property-overview',
  templateUrl: './property-overview.component.html',
  styleUrls: ['./property-overview.component.scss'],
})
export class PropertyOverviewComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('mapDialog', { static: false }) mapDialog: any;
  constructor(
    private currencyFormatterPipe: CurrencyFormatterPipe,
    private datePipe: DatePipe,
    private isValueExistPipe: IsValueExistPipe,
    private myHomeState: MyHomeState,
    private myHomeService: MyHomeService,
    private formBuilder: FormBuilder,
    private activityLoggerService: ActivityLoggerService,
    private appState: AppState,
    private dialog: MatDialog
  ) { }
  @Input() address;
  @Input() currentValue: number;
  @Input() propmixValue: number;
  @Input() loanBalance: number;
  @Input() netEquity: number;
  @Input() appreciateRatio: number;
  @Input() purchaseValue: number;
  @Input() source: string;

  isLoadingImageTrue: boolean = false;
  defaultPropertyImage: string;
  isStreetView: boolean = true;
  isStreetViewAvailable = true;
  setBirdsEyeViewEvent: object;
  birdsEyeView: any;
  dialogRef!: MatDialogRef<any>;
  streetView = true;
  selectedMapView: any;
  setStreetViewEvent: object;
  defaultPlace: { lat: number; lng: number };
  selectedView: string = 'streetView';
  activeAVMHistory$;
  firstAVMValue = null;
  soldDate;
  activeAVMHistory = null;
  loggerAddress: any;
  pmxPropertyId;
  AVMHistoryDetails: Array<any>;
  isLoading = true;
  lat: number;
  lng: number;
  currentTemperature: number = 0;
  weatherCondition: string = '';
  spendForecastForm = this.formBuilder.group({
    customCurrentValue: new FormControl(null),
    customPropmixValue: new FormControl(null),
    customPurchaseValue: new FormControl(null),
  });
  sentContactMailInprogress: boolean = false;
  onDestroyNotifier$ = new Subject();
  listingImageBaseUrl = environment.listingImageBaseUrlAlt;
  newMyProperty: boolean = false;

  @Output() currentValueEvent = new EventEmitter<number>();
  @Output() propmixValueEvent = new EventEmitter<number>();
  @Output() purchaseValueEvent = new EventEmitter<number>();
  @ViewChild('currentValuePopover') currentValuePopover: NgbPopover;
  @ViewChild('purchaseValuePopover') purchaseValuePopover: NgbPopover;
  @ViewChild('propmixValuePopover') propmixValuePopover: NgbPopover;
  @Output() mortgageSectionToScroll: EventEmitter<any> = new EventEmitter<any>();
  @Output() equitySectionToScroll: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    this.newMyProperty = this.appState.companyInfoValue.appConfig?.myProperty?.isEnabled || false;
    if (this.source == 'equityAnalysis') {
      this.newMyProperty = true;
    }
    this.myHomeState.activePropertyDetails$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res && res.basic) {
        this.soldDate = res.basic.Lst_CloseDate;
        this.pmxPropertyId = res.basic.PMXPropertyId;
        this.lat = res.basic.Latitude;
        this.lng = res.basic.Longitude;
        this.loggerAddress = {
          city: res.basic.City,
          state: res.basic.StateOrProvince,
          street: res.basic.StreetAddress,
          zip: res.basic.PostalCode,
        };
      }
      if (res && res.avmList) {
        let activeAVMHistory = res && res.avmList ? res.avmList : [];
        this.formatAVMHistoryDetails(activeAVMHistory);
      }
      this.isLoadingImageTrue = true;
      if (this.myHomeState.activeHomeValue && this.myHomeState.activeHomeValue.defaultPropertyImage != null) {
        this.defaultPropertyImage = this.myHomeState.activeHomeValue.defaultPropertyImage;
        this.defaultPropertyImage = this.defaultPropertyImage + '&height=280';
      } else if (res && res.imageList && res.imageList.length) {
        this.defaultPropertyImage =
          this.listingImageBaseUrl + '?ListingId=' + (this.address.lstListingId || res?.listing?.ListingId || 'null') + '&imageName=1&height=280';
      } else {
        this.defaultPropertyImage = null;
      }
      setTimeout(() => {
        this.isLoadingImageTrue = false;
      }, 1000);
    });

    this.myHomeState.activeHomeValuesLoader$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.isLoading = status;
    });

    if (this.newMyProperty && this.source != 'equityAnalysis') {
      this.myHomeService.getWeather(this.lat, this.lng).subscribe((data: any) => {
        if (data.current) {
          this.currentTemperature = data.current.temp_f;
          this.weatherCondition = data.current.condition.text;
        }
      });
    }
  }

  isNegativeOrder(value: number): boolean {
    return value < 0;
  }

  onMortgageScroll(event: Event) {
    this.mortgageSectionToScroll.emit(event);
  }

  onEquityScroll(event: Event) {
    this.equitySectionToScroll.emit(event);
  }

  ngOnChanges() {
    if (!this.address) this.address = {};
    this.spendForecastForm.controls.customCurrentValue.setValue(
      this.address.customCurrentValue ? this.address.customCurrentValue : this.currentValue,
      { emitEvent: false }
    );
    this.spendForecastForm.controls.customPropmixValue.setValue(
      this.address.customPropmixValue ? this.address.customPropmixValue : this.propmixValue,
      {
        emitEvent: false,
      }
    );
    this.spendForecastForm.controls.customPurchaseValue.setValue(
      this.address.customPurchaseValue
        ? this.address.customPurchaseValue
        : this.purchaseValue
          ? this.purchaseValue
          : null,
      {
        emitEvent: false,
      }
    );
    if (this.address) {
      this.defaultPlace = this.address.coordinate ? this.address.coordinate : {};
      this.showMap();
    }
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  setStreetView(event: any) {
    this.streetView = event;
  }
  setBirdsEyeView(event: any) {
    this.birdsEyeView = event;
    this.setBirdsEyeViewEvent = this.defaultPlace;
  }

  showMap(viewChange?) {
    this.selectedView = viewChange ? viewChange.source.value : this.selectedView;
    if (this.selectedView === 'birdsEyeView') {
      this.setStreetViewEvent = null;
      this.setBirdsEyeViewEvent = this.defaultPlace;
      this.isStreetView = false;
    } else {
      this.setBirdsEyeViewEvent = null;
      this.setStreetViewEvent = this.defaultPlace;
      this.isStreetView = true;
    }
  }

  onStreetViewAvailable(isAvailable: boolean) {
    this.isStreetViewAvailable = isAvailable;
  }

  onViewChange(viewChange: MatRadioChange) {
    this.selectedMapView = viewChange.source.value;
    if (this.selectedMapView === 'birdsEyeView') {
      this.isStreetView = false;
    } else {
      this.isStreetView = true;
    }
  }
  openMapDialog(): void {
    this.dialogRef = this.dialog.open(this.mapDialog, {
      width: '900px',
      height: '600px',
      data: {},
      disableClose: true, //  clicking outside
    });
  }

  closeMapDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    } else {
      console.error('Dialog reference is undefined.');
    }
    this.setStreetViewEvent = this.defaultPlace;
    this.isStreetView = true;
    this.setBirdsEyeViewEvent = null;
  }

  saveValue(event) {
    if (event == 'customPurchaseValue') {
      this.saveEdited(event);
      this.purchaseValueEvent.emit(this.spendForecastForm.controls.customPurchaseValue.value);
      this.purchaseValuePopover.close();
      this.logUserActivity(
        constant.LOGGER.myHome.category,
        constant.LOGGER.myHome.action.purchasePriceUpdate.key,
        this.pmxPropertyId,
        this.loggerAddress
      );
    }
  }

  logUserActivity(category, action, PMXPropertyId, address) {
    let loggerParams = {
      category: category,
      action: action,
    };
    let inputData = { PMXPropertyId: PMXPropertyId, address: address };
    this.activityLoggerService.logActivity(loggerParams, inputData);
  }

  revertValue(event) {
    let propertyValues = this.myHomeState.activeHomePropertyValue.find(
      (prop) => prop.pmxPropertyId == this.address.PMXPropertyId
    );
    if (event == 'customCurrentValue') {
      this.spendForecastForm.controls.customCurrentValue.setValue(propertyValues.currentValue, { emitEvent: false });
    } else if (event == 'customPropmixValue') {
      this.spendForecastForm.controls.customPropmixValue.setValue(propertyValues.propmixValue, { emitEvent: false });
    } else if (event == 'customPurchaseValue') {
      this.spendForecastForm.controls.customPurchaseValue.setValue(this.myHomeState.activeHomeValue.purchaseValue, {
        emitEvent: false,
      });
    }
  }

  saveEdited(event) {
    let myHomeValues = this.myHomeState.myHomeListValue.filter((myHome) => {
      return myHome.id == this.myHomeState.activeHomeValue.id;
    });
    myHomeValues = myHomeValues[0];
    if (event == 'customPurchaseValue') {
      myHomeValues.customPurchaseValue = this.spendForecastForm.controls.customPurchaseValue.value.toFixed() || 0;
    }
    this.myHomeService
      .updateMyHomeValues([myHomeValues], false)
      .pipe()
      .subscribe((res: any) => { });
  }

  // updateMyHomeValuesInState() {
  //   let params = {
  //     PMXPropertyId: this.address.PMXPropertyId,
  //     bathCount: this.address.bathCount,
  //     bedCount: this.address.bedCount,
  //     city: this.address.city,
  //     coordinate: this.address.coordinate,
  //     currentPropertyValue: this.currentValue,
  //     id: this.address.id,
  //     livingAreaSize: this.address.livingAreaSize,
  //     lotSize: this.address.lotSize,
  //     propertySubType: this.address.propertySubType,
  //     propertyType: this.address.propertyType,
  //     propmixPropertyValue: this.propmixValue,
  //     purchaseDate: this.address.purchaseDate,
  //     purchaseValue: this.purchaseValue,
  //     state: this.address.state,
  //     streetAddress: this.address.streetAddress,
  //     streetName: this.address.streetName,
  //     streetNumber: this.address.streetNumber,
  //     zip: this.address.zip,
  //   };
  //   this.myHomeService.updateMyHomeValuesInState(params);
  // }

  formatAVMHistoryDetails(avmHistory) {
    this.AVMHistoryDetails = [];
    avmHistory.forEach((avm) => {
      avm.AVMValue = this.currencyFormatterPipe.transform(this.isValueExistPipe.transform(avm.AVMValue));
      avm.AVMLowValue = this.currencyFormatterPipe.transform(this.isValueExistPipe.transform(avm.AVMLowValue));
      avm.AVMHighValue = this.currencyFormatterPipe.transform(this.isValueExistPipe.transform(avm.AVMHighValue));
      avm.AVMValuationDate = this.datePipe.transform(
        this.isValueExistPipe.transform(avm.AVMValuationDate),
        'MM/dd/yyyy'
      );
      this.AVMHistoryDetails.push(avm);
    });
    this.AVMHistoryDetails.sort((a: any, b: any) => {
      return new Date(a.AVMValuationDate).getTime() - new Date(b.AVMValuationDate).getTime();
    });
  }

  contactAgent() {
    this.myHomeService
      .contactAgent({ homeId: this.myHomeState.activeHomeValue.id })
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.sentContactMailInprogress = res.isLoading;
      });
  }

  isHideDealButton() {
    this.myHomeState.isMyHomeAddressValue = true;
  }
}
